import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { GetBillingTypes } from '@/graphql/contracts/_generated_/getBillingTypes.query';
import GetBillingTypesQuery from '@/graphql/contracts/getBillingTypes.query.gql';

export function getBillingTypes(): BillingType[] {
  const result = apolloClientContracts.readQuery<GetBillingTypes>({
    query: GetBillingTypesQuery
  });

  return result?.billingTypes || [];
}
